import { Tag } from '@cian/components';
import * as React from 'react';

import { ESuburbanUtility } from '../../../../json_query';
import { ISuburbanUtilityTag } from '../../../state/tags/definitions/suburban_utilities';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ISuburbanUtilityTagItemProps {
  tag: ISuburbanUtilityTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const utilitiesMap = {
  [ESuburbanUtility.Gas]: 'С газом',
  [ESuburbanUtility.Water]: 'Есть водоснабжение',
  [ESuburbanUtility.Drainage]: 'С канализацией',
  [ESuburbanUtility.Electricity]: 'С электричеством',
};

export const SuburbanUtilityTagItem = ({ tag, onDeleteClick, withNewTag }: ISuburbanUtilityTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {utilitiesMap[tag.value]}
    </TagComponent>
  );
};
